module.exports = __webpack_public_path__ + "img/carousel-3.31d7717b.png";